<template>
  <span v-if="visible"></span>
</template>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppInputNone extends AppComponent {
  get visible () {
    return false;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputNone.vue